import { render, staticRenderFns } from "./cmpFrame.vue?vue&type=template&id=d851ce5c&scoped=true"
import script from "./cmpFrame.vue?vue&type=script&lang=js"
export * from "./cmpFrame.vue?vue&type=script&lang=js"
import style0 from "./cmpFrame.vue?vue&type=style&index=0&id=d851ce5c&prod&lang=less"
import style1 from "./cmpFrame.vue?vue&type=style&index=1&id=d851ce5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d851ce5c",
  null
  
)

export default component.exports